export const REPORT_FILTER_PRESET_TYPES = {
  approachingStatutes: "APPROACHING_STATUTES_REPORT",
  matterDemand: "MATTER_DEMAND_REPORT",
  matterRecordRequests: "MATTER_RECORD_REQUESTS_REPORT",
  matterActivity: "MATTER_ACTIVITY_REPORT",
  matterSettlement: "MATTER_SETTLEMENT_REPORT",
  matterStatusCount: "MATTER_STATUS_COUNT_REPORT",
  openMatters: "OPEN_MATTERS_REPORT",
  userProductivity: "USER_PRODUCTIVITY_REPORT",
} as const;
